// import tenant pages
import coverSheet from '../pages/scs/coverSheet';
import businessObjective from '../pages/scs/businessObjective';
import shareObjectiveWithTeam from '../pages/scs/shareObjectiveWithTeam';
import minStandardFinance from '../pages/scs/minStandardFinance';
import minStandardCorporate from '../pages/scs/minStandardCorporate';
import minStandardLeadership from '../pages/scs/minStandardLeadership';
import minStandardDiversityInclusion from '../pages/scs/minStandardDiversityInclusion';
import performanceConversationQ1 from '../pages/scs/performanceConversationQ1';
import performanceConversationQ2 from '../pages/scs/performanceConversationQ2';
import performanceConversationQ3 from '../pages/scs/performanceConversationQ3';
import performanceConversationQ4 from '../pages/scs/performanceConversationQ4';
import talentCareerQ1 from '../pages/scs/talentCareerQ1';
import talentCareerQ2 from '../pages/scs/talentCareerQ2';
import talentCareerQ3 from '../pages/scs/talentCareerQ3';
import talentCareerQ4 from '../pages/scs/talentCareerQ4';
import approvalQ1 from '../pages/scs/approvalQ1';
import approvalQ2 from '../pages/scs/approvalQ2';
import approvalQ3 from '../pages/scs/approvalQ3';
import approvalQ4 from '../pages/scs/approvalQ4';

import type { FormConfig } from '../types';

const formConfig: FormConfig = {
  live: true,
  formCloseAt: '2026-10-20',
  strictDeadline: false,
  id: 'scs',
  formName: 'SCS Contribution',
  requiredFlag: true,
  title: 'SCS Contribution Capture',
  subTitle: 'Summary page',
  showSections: true,
  approval: 'always',
  register: true,
  approvalDecisionHint:
    'If you reject this form, the author will have the option to update and resubmit it.<br />This form, once approved, will be shared with the central Performance Management team and Moderation chairs',
  approvalAllowUnsubmit: false,
  approvalCloseOnQuarter: 'Q4',
  allowUnlock: 'formClose',
  identifier: '{person-details-scs-name}',
  sections: [
    {
      title: 'Cover Sheet',
      slug: 'cover-sheet',
      subsections: [
        {
          title: 'Your Details',
          slug: 'cover-sheet',
          pages: coverSheet,
        },
      ],
    },

    {
      title: 'Objective Setting',
      slug: 'objectives',
      subsections: [
        {
          title: 'Business Objectives',
          slug: 'business-objective',
          dependsOn: 'cover-sheet',
          pages: businessObjective,
        },
        {
          title: 'Share objectives with your team',
          slug: 'share-objective-with-team',
          dependsOn: 'business-objective',
          pages: shareObjectiveWithTeam,
        },
      ],
    },
    {
      title: 'Minimum Standards',
      slug: 'minimum-standard',
      subsections: [
        {
          title: 'Finance',
          slug: 'finance',
          pages: minStandardFinance,
        },
        {
          title: 'Corporate',
          slug: 'corportate',
          pages: minStandardCorporate,
        },
        {
          title: 'Leadership',
          slug: 'leadership',
          pages: minStandardLeadership,
        },
        {
          title: 'Diversity & Inclusion',
          slug: 'diversity-inclusion',
          pages: minStandardDiversityInclusion,
        },
      ],
    },

    {
      title: 'Quarter 1 (April to June) - Quarter 1 review',
      slug: 'quarter-1-review',
      quarterReview: {
        quarter: 'Q1',
      },
      subsections: [
        {
          title: 'Quarter 1 Performance',
          slug: 'performance-q1',
          pages: performanceConversationQ1,
        },
      ],
    },
    {
      title: 'Quarter 2 (July to September) - Mid Year Assessment',
      slug: 'quarter-2-review',
      availableFrom: {
        month: 9,
        day: 1,
      },
      quarterReview: {
        quarter: 'Q2',
      },
      subsections: [
        {
          title: 'Quarter 2 Performance',
          slug: 'performance-q2',
          pages: performanceConversationQ2,
        },
        {
          title: 'Quarter 2 Career Development',
          slug: 'talent-development-q2',
          pages: talentCareerQ2,
        },
      ],
    },
    {
      title: 'Quarter 3 (October to December) - Quarter 3 review',
      slug: 'quarter-3-review',
      availableFrom: {
        month: 12,
        day: 1,
      },
      quarterReview: {
        quarter: 'Q3',
      },
      subsections: [
        {
          title: 'Quarter 3 Performance',
          slug: 'performance-q3',
          pages: performanceConversationQ3,
        },
      ],
    },
    {
      title: 'Quarter 4 (January to March) - End of year assessment',
      slug: 'quarter-4-review',
      availableFrom: {
        month: 3,
        day: 1,
        yearOffset: 1,
      },
      quarterReview: {
        quarter: 'Q4',
      },
      subsections: [
        {
          title: 'Quarter 4 Performance',
          slug: 'performance-q4',
          pages: performanceConversationQ4,
        },
        {
          title: 'Quarter 4 Talent Assessment & Career Development',
          slug: 'talent-development-q4',
          pages: talentCareerQ4,
        },
      ],
    },
    {
      title: 'Approvals',
      slug: 'approvals',
      subsections: [
        {
          title: 'Approval',
          slug: 'approval',
          pages: [...approvalQ1, ...approvalQ2, ...approvalQ3, ...approvalQ4],
        },
      ],
    },
  ],
};
export default formConfig;
